import type { ReactNode } from 'react';
import type { UserRole } from '@emazy/shared-types';
import { Navigate, useLocation } from 'react-router-dom';

import { BrandedLoadingState } from '@/components/common';
import { buildLoginRoute, routes } from '@/config/routes';
import { useAuth } from '@/features/auth/context';
import { hasAnyRole } from '@/features/auth/utils/authorization';

export function RequireRole({
  children,
  allowedRoles,
}: {
  children: ReactNode;
  allowedRoles: readonly UserRole[];
}) {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'initializing') return <BrandedLoadingState />;
  if (!user)
    return (
      <Navigate
        to={buildLoginRoute({ redirect: `${location.pathname}${location.search}${location.hash}` })}
        replace
      />
    );
  if (!hasAnyRole(user, allowedRoles)) return <Navigate to={routes.unauthorized} replace />;
  return children;
}
